import { render, staticRenderFns } from "./ConsultantDetailsEdit.vue?vue&type=template&id=741eb6c6"
import script from "./ConsultantDetailsEdit.vue?vue&type=script&lang=js"
export * from "./ConsultantDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports